import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '../stores/useAuthStore';

const ROLE_HOME: Record<string, string> = {
  ADMIN: '/admin',
  MENTOR: '/mentor',
  STUDENT: '/student',
};

export default function ProtectedRoute({ requiredRole }: { requiredRole?: string }) {
  const { isAuthenticated, role } = useAuthStore();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (requiredRole && role !== requiredRole) {
    return <Navigate to={ROLE_HOME[role ?? ''] ?? '/login'} replace />;
  }

  return <Outlet />;
}
